
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coachingcenter",
      function () {
        return require("private-next-pages/coachingcenter.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coachingcenter"])
      });
    }
  